var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEmail = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A5569"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.641 1.651l-8.445 8.05c-.605.579-1.4.867-2.196.867-.795 0-1.59-.29-2.196-.866L.359 1.65C.133 2.024 0 2.46 0 2.928v11.104C0 15.39 1.1 16.5 2.444 16.5h17.112C20.9 16.5 22 15.39 22 14.032V2.928c0-.467-.133-.903-.359-1.277z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.376 8.278L20.9.325A2.481 2.481 0 0019.674 0H2.326C1.88 0 1.462.12 1.1.325l8.524 7.953c.746.697 2.006.696 2.752 0z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.e5b200f6.svg";
export { ForwardRef as ReactComponent };